<div class="container-fluid min-vh-100 d-flex flex-column">
  <div class="row sticky-top">
    <nav ngbNav class="navbar navbar-expand-sm bg-body-tertiary" data-bs-theme="dark">
      <div class="container-fluid">
        <a class="navbar-brand" routerLink="/home/user">
          <img src="assets/spotfight-small.png" alt="Logo" height="30px" class="d-inline-block align-text-top">
        </a>
        <button class="navbar-toggler navbar-toggler-right" type="button" (click)="navbarCollapsed = !navbarCollapsed"
          [attr.aria-expanded]="!navbarCollapsed"
          aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown" [ngbCollapse]="navbarCollapsed">
          <ul class="navbar-nav">
            <li class="nav-item">
              <button class="nav-link" routerLink="/home/events" routerLinkActive="active">EVENTS</button>
            </li>
            <li class="nav-item">
              <button class="nav-link" routerLink="/home/scoreboard" routerLinkActive="active">BESTENLISTE</button>
            </li>
            <li class="nav-item">
              <a class="nav-link" [attr.href]=prices_url target="_blank">REGELN & PREISE</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www.spotfight.de/tippspiel-hof" target="_blank">HALL OF FAME</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www.spotfight.de/tippalarm/" target="_blank">TIPPSPIEL-ALARM</a>
            </li>
            @if (showAdminLink()) {
              <li class="nav-item">
                <button class="nav-link" routerLink="/home/admin" routerLinkActive="active">ADMIN</button>
              </li>
            }
          </ul>
          <ul class="navbar-nav ms-auto me-2">
            <li class="nav-item">
              <button class="nav-link" routerLink="/home/settings" routerLinkActive="active" ngbTooltip="Einstellungen" placement="bottom">
                <i class="bi bi-gear"></i>
              </button>
            </li>
          </ul>
          <ul class="navbar-nav me-2">
            <li class="nav-item">
              <button class="nav-link" (click)="logout()" ngbTooltip="Logout" placement="bottom">
                <i class="bi bi-box-arrow-right"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <div class="row flex-fill spotfight-bg">
    <div class="container">
      <div class="container p-5 spotfight-content-wrapper">
        <router-outlet/>
      </div>
    </div>
  </div>

  <div class="row" [ngClass]="{'sticky-bottom': !isMobile}">
    <nav class="navbar navbar-expand-lg bg-body-tertiary justify-content-end" data-bs-theme="dark">
      <ul class="navbar-nav ">
        <li class="nav-item">
          <a class="nav-link" href="https://koelnsport-verlag.de/impressum/" target="_blank">Impressum</a>
        </li>
        <li class="nav-item me-3">
          <a class="nav-link" href="https://koelnsport-verlag.de/datenschutzerklaerung/" target="_blank">Datenschutz</a>
        </li>
        <li class="nav-item align-self-center text-muted small me-3">
          <span class="nav-link disabled">v{{ version }}</span>
        </li>
      </ul>
    </nav>
  </div>
</div>
